module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/font/glyphicons-halflings-regular.ttf
// module id = Cmta
// module chunks = 0